module.exports = __webpack_public_path__ + "img/11a-analises-todas-show.e9af2eaf.png";